var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-controller',_vm._b({},'base-controller',{ ..._vm.$props, ..._vm.$attrs },false),[_c('div',{staticClass:"select"},[_c('select',{domProps:{"value":_vm.value},on:{"change":_vm.onChange}},_vm._l((_vm.items),function(item,idx){return _c('option',{key:item,domProps:{"value":idx}},[_vm._v(_vm._s(_vm._f("uppercase")(item)))])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }